import script from "./StudentTile.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTile.vue?vue&type=script&setup=true&lang=js"

import "./StudentTile.vue?vue&type=style&index=0&id=c4cdcb34&lang=scss"

const __exports__ = script;

export default __exports__